module.exports = __webpack_public_path__ + "static/img/log.cbf3710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/log.png
// module id = 5vAY
// module chunks = 1